import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

const CATEGORY_LABELS = {
  skeleton_trailers: "Skeleton Trailers",
  flatbed_trailers: "Flatbed Trailers",
  metals: "Metals",
  cargo: "General Cargo",
};

const PLACEHOLDER = "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600";

export default function ProductCard({ product }) {
  const image = product.images && product.images.length > 0 ? product.images[0] : PLACEHOLDER;

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group bg-[#0A0A12] border border-white/10 rounded-lg overflow-hidden transition-all duration-300 hover:border-[#DC143C]/50 hover:shadow-[0_0_24px_rgba(220,20,60,0.15)] card-glow"
    >
      <Link to={`/product/${product.id}`} className="block">
        {/* Image */}
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={image}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-3 left-3 flex gap-2">
            <Badge
              className="bg-[#000080]/60 text-[#F3F4F6] border border-[#7851A9]/40 uppercase text-[10px] font-bold tracking-widest backdrop-blur-sm"
            >
              {product.condition}
            </Badge>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-[#9CA3AF] text-xs uppercase tracking-[0.15em] mb-1.5">
            {CATEGORY_LABELS[product.category] || product.category}
          </p>
          <h3 className="text-white font-semibold text-base leading-snug mb-3 group-hover:text-[#DC143C] transition-colors">
            {product.title}
          </h3>
          <span className="inline-flex items-center text-[#DC143C] text-sm font-medium tracking-wide">
            Inquire Now
            <svg className="ml-1.5 w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </span>
        </div>
      </Link>
    </div>
  );
}
